import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AppContainer = styled.div`
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #FFFFFF;
  color: #1f2937;
  overflow-x: hidden;
  line-height: 1.6;
  width: 100%;
  max-width: 100vw;
`;

export const Navbar = styled(motion.nav)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  background: #000000;
  padding: 1.25rem 8rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 2rem;
  z-index: 1000;
  box-sizing: border-box;
  border-radius: 0;
  width: 100%;
  max-width: 100%;

  @media (max-width: 968px) {
    grid-template-columns: auto auto;
    padding: 0.8rem 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1rem;
  }
`;

export const Logo = styled.div`
  justify-self: start;
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  height: 30px;
  width: auto;
  @media (max-width: 768px) {
    height: 32px;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 968px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.7;
  }
`;

export const BetaButton = styled(motion.button)`
  background-color: #D1FF94;
  color: black;
  padding: 0.7rem 1.8rem;
  border: none;
  border-radius: 70px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
  flex-shrink: 0;
  text-decoration: none;
  display: inline-block;
  justify-self: end;

  &:hover {
    background-color: #D1FF99;
    color: #000;
  }
  @media (max-width: 768px) {
    padding: 0.6rem 1.4rem;
    font-size: 0.85rem;
  }
`;

export const Footer = styled.footer`
  background-color: #000;
  color: #e5e7eb;
  padding: 3rem 2rem;
  text-align: center;
  font-size: 0.9rem;
`;
